import { normalize } from 'normalizr';
import {
  weployerTimesheets as timesheetSchema,
} from '../common/schema';
import {
  TIMESHEETS_FETCH,
  TIMESHEET_FETCH_SUCCESS,
  TIMESHEETS_FETCH_SUCCESS,
  TIMESHEET_REJECT_SUCCESS,
} from './actionTypes';

export const initialState = {
  loading: false,
  timesheets: undefined,
  totalTimesheetsCount: undefined,
  orderedTimesheetIds: [],
  deeplinkedTimesheetId: undefined,
};

const mergeStore = (prevStore, newStore, reset = false) => {
  const {
    timesheets,
    orderedTimesheetIds,
  } = reset ? initialState : prevStore;

  return {
    loading: false,
    timesheets: { ...timesheets, ...newStore.timesheets },
    orderedTimesheetIds: [...orderedTimesheetIds, ...(newStore.orderedTimesheetIds || [])],
    totalTimesheetsCount: newStore.totalTimesheetsCount,
    deeplinkedTimesheet: newStore.deeplinkedTimesheet,
  };
};

export const reducer = (state, action) => {
  switch (action.type) {
    case TIMESHEET_FETCH_SUCCESS: {
      const { payload } = action;
      const { timesheet } = payload;
      const deeplinkedTimesheetId = timesheet.id;
      const { timesheets } = normalize({ timesheets: [timesheet] }, timesheetSchema).entities;
      const newStore = {
        deeplinkedTimesheet: timesheets[deeplinkedTimesheetId],
      };

      return mergeStore(state, newStore);
    }
    case TIMESHEETS_FETCH: {
      return { ...state, loading: true };
    }
    case TIMESHEETS_FETCH_SUCCESS: {
      const { payload, reset } = action;
      const { timesheets, totalTimesheetsCount } = payload;
      const orderedTimesheetIds = timesheets.map(timesheet => timesheet.id);
      const newStore = {
        ...normalize(payload, timesheetSchema).entities,
        orderedTimesheetIds: [...orderedTimesheetIds],
        loading: false,
        totalTimesheetsCount,
      };

      return mergeStore(state, newStore, reset);
    }
    case TIMESHEET_REJECT_SUCCESS: {
      const { payload } = action;
      const { timesheetId, rejectionReason } = payload;
      const rejectedTimesheet = {
        ...state.timesheets[timesheetId],
        rejectionState: 'REJECTED',
        rejectionReason: rejectionReason.trim(),
      };
      const newStore = {
        timesheets: {
          [timesheetId]: rejectedTimesheet,
        },
      };

      return mergeStore(state, newStore);
    }
    default:
      return state;
  }
};

export default {
  initialState,
  reducer,
};
